/**
 * Long-Term Disability coverage skeleton
 */

import {
  BenefitPlanTypeEnum,
  CoverageTypeEnum,
  FundingTypeEnum,
  PlanOptionNameEnum,
  RfpBenefitPlan,
  RfpCoverage,
} from "../../types/rfp.api.types";

export const getLtdSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.LTD,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "ltd-plan-1",
      name: "Long-Term Disability Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: "newBusiness",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        benefitAmount: { type: "percentageOfEarnings", percentage: 0 },
        maximumMonthlyBenefit: { type: "dollarAmount", amount: 0 },
        minimumMonthlyBenefit: { type: "dollarAmount", amount: 0 },
        eliminationPeriod: { type: "days", days: 0 },
        benefitDuration: { type: "toAge", age: 0 },
        definitionOfDisability: "",
        definitionOfEarnings: { type: "baseSalaryOrHourlyWages" },
        preExistingCondition: {
          type: "extended",
          treatmentLookback: 0,
          disabilityLookback: 0,
        },
        mentalNervousLimitation: "",
        substanceAbuseLimitation: "",
        cola: "",
        socialSecurityIntegration: "",
      },
    } as RfpBenefitPlan,
  ],
});
